import { gql } from '@apollo/client';

export const DASHBOARD_ACTIVITIES = gql`
  query DashboardActivities($input: FilterArgs) {
    totalApprovedSessions(input: $input) {
      month
      count
    }
  }
`;
